import gaOperationCoreInstanceEn from './instance/default';
import pagesGAOperationCoreOperationPackagesEn from './operation-packages/default';
const pagesGAOperationCoreEn = {
  instance: gaOperationCoreInstanceEn,
  operationPackages: pagesGAOperationCoreOperationPackagesEn
};
export default pagesGAOperationCoreEn;